import LoadingState from 'components/LoadingState';
import { centsToDollarsString } from 'lib/helpers';

type PricingComparisonProps = {
  oldTotalInCents: number;
  totalInCents: number;
  invoiceLoading: boolean;
  isPartialRefund: boolean;
};

function PricingData({ price }: { price: number }) {
  return (
    <div className="text-sm font-semibold">{`$${centsToDollarsString(
      price
    )}`}</div>
  );
}

function PricingComparison({
  oldTotalInCents,
  totalInCents,
  invoiceLoading,
  isPartialRefund
}: PricingComparisonProps) {
  return (
    <>
      <div className="mb-4">
        <div className="flex justify-between items-center py-1">
          <div>Old price</div>
          <div className="text-column-red-700 line-through">
            <PricingData price={oldTotalInCents} />
          </div>
        </div>
        <div className="flex justify-between items-center py-1">
          <div>New price</div>
          <div className="text-sm font-semibold text-column-green-600">
            {invoiceLoading ? (
              <LoadingState isFullScreen={false} />
            ) : (
              <PricingData price={totalInCents} />
            )}
          </div>
        </div>
        {isPartialRefund && (
          <div className="flex justify-between items-center py-1">
            <div>Refund</div>
            <div className="text-sm font-semibold">
              <PricingData price={oldTotalInCents - totalInCents} />
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default PricingComparison;
